import { HttpBackend, HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable()
export class CboService {

    token!: string | null;
    private httpClient: HttpClient;

    constructor(handler: HttpBackend) {
        this.httpClient = new HttpClient(handler);
    }

    getToken(obj: any) {
        const header = new HttpHeaders()
        .set(
            "content-type",
            "application/json"
        )
        .set(
            "APP_ID",
            "a0bcdeda-f337-4716-a270-aea421c966d0"
        )
        return this.httpClient.post(`https://pruc9999999.eiconbrasil.com.br/loginunico/api/v2/token`, obj, {headers: header})
    }

    getCbo(token: string) {
        const header = new HttpHeaders()
        .set(
            "Authorization",
            `Bearer ${token}`
        )
        return this.httpClient.get(`https://cbo.eiconbrasil.com.br/api/v2/ocupacao/obter-todos`, {headers: header})
    }
}